import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/repositorio/participantes-finales/nuevos';

/**
 * Obtiene los documentos de participantes finales nuevos
 * @param {number} oidProyecto - obligatorio
 * @param {string} cedula - opcional
 */
const getParticipantesFinalesNuevos = async (oidProyecto, cedula = null) => {
  try {
    if (!oidProyecto) {
      throw new Error('oidProyecto es obligatorio');
    }

    const response = await axios.get(`${baseUrl}${endpoint}`, {
      params: {
        oidProyecto,
        ...(cedula && { cedula })
      }
    });

    return {
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error(
      '❌ Error fetching participantes finales nuevos:',
      error
    );

    return {
      status: error.response ? error.response.status : 500,
      message: 'Error consultando participantes finales nuevos'
    };
  }
};

export default getParticipantesFinalesNuevos;
